import { Notification } from 'element-ui';
import moment from 'moment';
import repositoryFactory from '@/helpers/api/apiFactory';
const api = repositoryFactory('simulation');

import { deepCopy } from '@/helpers/utils'

const from = moment().format('yyyy-MM-DD');
const to = moment().add(9, 'days').format('yyyy-MM-DD');

const initialForm = {
    orders: {
        quantity: 400,
        with_two_masters: 1,
        duration: {
            from: 60,
            to: 180
        },
        start_late_qty: 100,
        start_late_duration: undefined,
        finish_delayed_qty: undefined,
        finish_delayed_duration: undefined,
        finish_ahead_qty: undefined,
        finish_ahead_duration: undefined,
        canceled: 1,
        carry_over: 100,
        areas: {
            area_a: {
                percent: 30,
                coefficient: 2.9,
                time: {
                    from: '10:00',
                    to: '15:00'
                }
            },
            area_b: {
                percent: 10,
                coefficient: 1.5,
                time: {
                    from: '10:00',
                    to: '16:00'
                }
            },
            area_c: {
                percent: 25,
                coefficient: 2.5,
                time: {
                    from: '16:00',
                    to: '18:00'
                }
            },
            area_d: {
                percent: 15,
                coefficient: 1.5,
                time: {
                    from: '12:00',
                    to: '18:00'
                }
            },
            area_e: {
                percent: undefined,
                coefficient: 2.9,
                time: {
                    from: '16:00',
                    to: '18:00'
                }
            }
        }
    },
    masters: {
        quantity: 10,
        working_timesheet: {
            not_go_work: 1,
            date: {
                from: from,
                to: to
            },
            time: {
                from: '09:00',
                to: '18:00'
            }
        },

        areas: {
            area_a: {
                percent: 35
            },
            area_b: {
                percent: 10
            },
            area_c: {
                percent: 20
            },
            area_d: {
                percent: 10
            },
            area_e: {
                percent: undefined
            }
        }
    },
    service: 'service',

}
 
const state = { 
    form: deepCopy(initialForm),
    simulations: null,
    simulation: null,
    indicators: null,
    simulationComments: null,
    meta: {
        current_page: 0,
        last_page: null
    },

    showMasterError: false,
    showOrdersError: false,
    params: {}
};

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    },
    clearForm: state => {
        state.form = deepCopy(initialForm)
    },
    setMeta: (state, value) => {
        if(value == null) {
            return;
        }

        state.meta.current_page = value.current_page;
        state.meta.last_page = value.last_page;
    },
    resetCurrentPage: state => state.meta.current_page = 1,
    clearSimulations: state => {
        state.simulations = null;
        state.meta = {
            current_page: 0,
            last_page: null
        };
    },
    incPage: state => {
        state.meta.current_page =  state.meta.current_page + 1;
    }
};

const actions = { 
    async create({state, commit}) {
        // commit('setForm');
        return await api.create(state.form); 
    },

    async get({state, commit}) { 
        try { 
            commit('incPage'); 
             
            if(state.meta.current_page > state.meta.last_page && state.meta.last_page != null) {
                return;
            }
                
            const response = await api.get(getQuery({
                page: state.meta.current_page,
                limit: 25,
                params: getParams(state.params)
            })); 
             
            commit('setMeta', {
                current_page: state.meta.current_page,
                last_page: response.data.meta.last_page
            });
            
            let value = null; 
            if(state.simulations == null ) { 
                value =  response.data.data !== undefined ? response.data.data : []
            }
            else {
                const currentData = state.simulations;
                value = currentData.concat(response.data.data);
            }

            commit('setState', {
                key: 'simulations',
                value 
            }); 
        } catch (err) {} 
    },

    async getFilter({state, commit}) {
        const response = await api.get(getQuery({
            page: state.meta.current_page,
            limit: 25,
            params: getParams(state.params)
        })); 
         
        commit('setMeta', {
            current_page: state.meta.current_page,
            last_page: response.data.meta.last_page
        });
        
        const value = response.data.data !== undefined ? response.data.data : []
         
        commit('setState', {
            key: 'simulations',
            value 
        }); 
    },

    async getByName({state, commit}, name) {
        const response = await api.getByName(name); 
         
        commit('setState', {
            key: 'indicators',
            value: response.data
        });
    },

    async getById({state, commit}, id) {
        const response = await api.getById(id); 
         
        commit('setState', {
            key: 'simulation',
            value: response.data.data
        });
    },

    async getComments({commit}, id) {
        const response = await api.getComments(id); 

        commit('setState', {
            key: 'simulationComments',
            value: response.data.data
        });

        return response.data.data;
    },

    async addComment({dispatch}, params) {
        const {id} = params;
       
        const response = await api.addComment(params);   
        await dispatch('getComments', id);
        
        return response;
    },

    async repeatSimulation({commit, dispatch}, form) { 
        const response = await api.create(form);  
        
        if(response.status === 201) {
            Notification({
                title: 'Created.',
                message: "You've created a new simulation",
                duration: 3000
            });
        }
    } 
};

const getters = { 
    formGetters: state => state.form,
    simulations: state => state.simulations,
    simulation: state => state.simulation,
    indicators: state => state.indicators,
    simulationComments: state => state.simulationComments,
 
    showMasterError: state => state.showMasterError,
    showOrdersError: state => state.showOrdersError,
    params: state => state.params
};

function getQuery({page = null, limit = null, params}) {
    let query = `?`;

    if(page != null) {
        query += `page=${page}&`;
    }   

    if(limit != null) {
        query += `limit=${limit}&`;
    }  
    
    if(params != null) {
        query += `${params}`;
    }   

    return query === '?' ? '' : query;
}

function getParams(params) {
    let query = ``; 
    
    if (params.hasOwnProperty('date_from') && params.date_from != null) {
        query += `date_from=${params.date_from}&`;
    } 
 
    if (params.hasOwnProperty('date_till') && params.date_till != null) {
        query += `date_till=${params.date_till}&`;
    } 
    
    if (params.hasOwnProperty('orders_quantity_from') && params.orders_quantity_from !== '') {
        query += `orders_quantity_from=${params.orders_quantity_from}&`;
    }
 
    if (params.hasOwnProperty('orders_quantity_to') && params.orders_quantity_to !== '') {
        query += `orders_quantity_to=${params.orders_quantity_to}&`;
    }
 
    if (params.hasOwnProperty('master_quantity_from') && params.master_quantity_from !== '') {
        query += `master_quantity_from=${params.master_quantity_from}&`;
    } 

    if (params.hasOwnProperty('master_quantity_to') && params.master_quantity_to !== '') {
        query += `master_quantity_to=${params.master_quantity_to}&`;
    }  

    if(params.hasOwnProperty('indicator_1_from') && params.indicator_1_from !== '') {
        query += `indicator_1_from=${params.indicator_1_from}&`;
    } 
    
    if(params.hasOwnProperty('indicator_1_to') && params.indicator_1_to !== '') {
        query += `indicator_1_to=${params.indicator_1_to}&`;
    } 

    if(params.hasOwnProperty('indicator_2_from') && params.indicator_2_from !== '') {
        query += `indicator_2_from=${params.indicator_2_from}&`;
    } 
    
    if(params.hasOwnProperty('indicator_2_to') && params.indicator_2_to !== '') {
        query += `indicator_2_to=${params.indicator_2_to}&`;
    } 

    if(params.hasOwnProperty('indicator_3_from') && params.indicator_3_from !== '') {
        query += `indicator_3_from=${params.indicator_3_from}&`;
    } 
    
    if(params.hasOwnProperty('indicator_3_to') && params.indicator_3_to !== '') {
        query += `indicator_3_to=${params.indicator_3_to}&`;
    }

    if(params.hasOwnProperty('indicator_4_from') && params.indicator_4_from !== '') {
        query += `indicator_4_from=${params.indicator_4_from}&`;
    } 
    
    if(params.hasOwnProperty('indicator_4_to') && params.indicator_4_to !== '') {
        query += `indicator_4_to=${params.indicator_4_to}&`;
    }

    if(params.hasOwnProperty('orderBy') && params.orderBy !== '') {
        query += `orderBy=${params.orderBy}&`;
    }

    if(params.hasOwnProperty('sortedBy') && params.sortedBy !== '') {
        query += `sortedBy=${params.sortedBy}&`;
    }
     
     
    return query;
} 

export default {
    namespaced: true,
    state, 
    mutations,
    actions,
    getters
};